import React, { Component } from 'react';
import './style.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Star from '../../../../_static/images/star.png';
import { MODAL_QUESTION_QUIZ_DELETE, showModal } from '../../../../modules/modals';
import { getQuiz } from '../../actions';

const Checkbox = ({value, onChange, label}) => {
  return <div className="toggle-block toggle-block--indent-bottom">
    <div className="toggle-component">
      <span className={classNames("toggle-label", {active: !!value})}>{label}</span>
      <div className={classNames("react-toggle", {'react-toggle--checked': value})} onClick={() => {onChange(!value)}}>
        <div className="react-toggle-track">
          <div className="react-toggle-track-check"></div>
          <div className="react-toggle-track-x"></div>
        </div>
      <div className="react-toggle-thumb"></div>
    </div>
  </div>
  </div>
}

class Question extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      showAnswer: false,
      showExplanation: false,
    }
  }

  getArrayAnswers = () => {
    const {question} = this.props;
    return Object.keys(question.answerT1).filter(key => key.indexOf('answer_') > -1 && !!question.answerT1[key]).map(key => ({value: question.answerT1[key], active: question.answerT1.correct_answer == key}))
  }
  

  render() {
    const {question, categories, subcategories, quiz_id, subjects, deleteQuizQuestion, branches, sources} = this.props;
    const {showAnswer, showExplanation} = this.state;
    const arrayChar = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    const {formatMessage} = this.context;

    let subject_name = '';

    const category = (categories.find(cat => cat.id == question.category_id) || {});

    if(category.branch_id){
      subject_name = (branches.find(item => category.branch_id == item.id) || {}).name
    }



    return (
      <div >
        <div className="question-body_buttons pb-4 pt-4">
          <div className="question-component">
            <div>
              <div className="question-header" >
                <div>
                  <span>#{question.id}</span>
                </div>
                <div>
                  <div className="word-wrap-break"> <span className="question_items">{formatMessage("Subject")}:</span> {subject_name || formatMessage("undefined")}</div>
                    <div className="word-wrap-break"><span className="question_items pointer">{formatMessage("Category")}:</span> {category.name || formatMessage("undefined")}</div>
                    <div className="word-wrap-break"><span className="question_items pointer">{formatMessage("Subcategory")}:</span> {(subcategories.find(cat => cat.id == question.subcategory_id) || {}).name || formatMessage("undefined")}</div>
                    <div className="word-wrap-break"><span className="question_items pointer">{formatMessage("Source")}:</span> {(sources.find(cat => cat.id == question.source_id) || {}).name || formatMessage("undefined")}</div>
                    <div className="word-wrap-break"><span className="question_items pointer">{formatMessage('titleQuestionDifficulty')}:</span> 
                      <div className="Difficulty">
                        <div>
                          {[1,2,3,4,5,6].map(i => 
                            <img 
                              key={'star-' + i}
                              className={classNames({active: question.difficulty >= i})}
                              src={Star}
                              alt="star"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
              </div>
              <div className="question-body">
                <div className="question-text-html" dangerouslySetInnerHTML={{ __html: question.question }} />
                <Checkbox value={showAnswer} onChange={(value) => {
                  this.setState({showAnswer: value})
                }} label={'Hide answers'} />
                

                {showAnswer ? <div className="answers-block">
                  {this.getArrayAnswers().map((answer, index) => <div className={classNames("answer-component", {right: answer.active})}>
                    <div className="answer-label">{arrayChar[index]}</div>
                    <div className="answer-content">{answer.value}</div>
                  </div>)}
                </div> : null}

                <Checkbox value={showExplanation} onChange={(value) => {
                  this.setState({showExplanation: value})
                }} label={'Hide explanation'} />

                {showExplanation ? <div className="question-text-html" dangerouslySetInnerHTML={{ __html: question.description }} /> : null}
              </div>
            </div>
              <div className="question-buttons">
                <div onClick={ async() => {
                  const {showModal} = this.props;
                  const {isAnswer} = await getQuiz(quiz_id);
                  showModal({
                    modalType : MODAL_QUESTION_QUIZ_DELETE,
                    modalProps : {
                      question_id: question.id,
                      quiz_id: quiz_id,
                      isAnswer,
                      deleteQuizQuestion: deleteQuizQuestion
                    }
                  })
                }}>
                  <img src="/build/images/GarbageButton.svg?dd496e1175bddf2473114d4037e004a8" title="Remove question" width="68" height="68"/>
                </div>
              </div>
            </div>
          </div>
        
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Question)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quiz/components/Questions/Question.jsx